import { Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function SupText({ onChange, item, onSave }) {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(item?.textboxValue)
  }, [item?.textboxValue])

  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (onSave) {
      setTouched(true);
    } else {
      setTouched(false);
    }

  }, [onSave]);

  const showError = (item.isMandatory && touched && (item.textboxValue === null || item.textboxValue === "")) ||
    (item.hasRadioBox && item.radioboxValue && touched && (item.textboxValue === null || item.textboxValue === ""));


  return (
    <>
      <TextField
        disabled={item.disabled}
        onBlur={onChange}
        onChange={e => {
          setValue(e.target.value)
        }}
        defaultValue={item?.textboxValue}
        value={value}
        inputProps={{
          style: {
            fontSize: '1rem', height: 5,
            color: item.disabled && 'black !important',
            backgroundColor: item.disabled && 'hsl(0, 0%, 95%)',
          },
        }}
        size="small"
        fullWidth

        error={showError}  // Show error based on value length
        helperText={showError ? 'This field is required' : ''}  // Show helperText if error
      />

    </>
  )
}
